import template from './product-detail.template.html';
import controller from './product-detail.controller';
import './product-detail.scss';

const productDetailComponent = {
  template,
  controller,
};

export default productDetailComponent;



// WEBPACK FOOTER //
// ./src/app/product/product-detail/product-detail.component.js